<template>
  <div class="col-md-12">
    <div class="d-flex align-items-center justify-content-between">
      <h6 v-if="requiredFileType">
        Tipo de archivo requerido:
        <b-badge variant="primary" class="ml-2">
          {{ requiredFileType }}
        </b-badge>
      </h6>
      <h6 v-if="acceptedFileExtensionsArray.length">
        Extensiones permitidas:
        <b-badge
          v-for="extension in acceptedFileExtensionsArray"
          :key="extension"
          variant="primary" class="ml-2"
        >
          {{ extension }}
        </b-badge>
      </h6>
      <div v-else />
      <b-button
        v-tooltip="tooltip"
        data-cy="select-document"
        class="badge-glow mb-2"
        :variant="disabled ? 'warning' : 'success'"
        size="sm"
        @click="onClick()"
        :disabled="disabled"
      >
        <feather-icon icon="CheckIcon" size="16" />
        Seleccionar
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rs-select-button',
  props: {
    tooltip: String,
    disabled: Boolean,
    onClick: Function,
    requiredFileType: String,
    acceptedFileExtensions: String,
  },
  computed: {
    acceptedFileExtensionsArray() {
      if (this.acceptedFileExtensions) {
        return this.acceptedFileExtensions
          .toUpperCase()
          .split(',');
      }

      return [];
    },
  }
};
</script>
